import {FC, useCallback, useEffect, useMemo, useState} from 'react';
import {TheButton} from '../../common/TheButton';
import {
  DateColumn,
  EnhancedDetailsList,
  OpenColumn,
  OtherColumn,
  RichtextColumn,
  SelectColumn,
  StringColumn
} from '../../common/EnhancedDetailsList';
import {Spinner} from '@fluentui/react';
import {
  ColumnKey,
  IEnhancedColumn,
  SpecialColumnKey
} from '../../common/EnhancedDetailsList/IEnhancedDetailsList';

import {MyAcknowledgementModel} from '../../../models/MyAcknowledgementModel';
import {UsersList} from './UsersListModal';
import {LinksListColumn} from '../../common/EnhancedDetailsList/ColumnTypes/LinksListColumn';
import {CopyColumn} from '../../common/EnhancedDetailsList/ColumnTypes/CopyColumn';
import {AcknowledgementStatus} from '../../../services/generated/models/AcknowledgementStatus';
import { UserDto } from '../../../services/generated';

interface IMyAcknowledgement {
  isInitiatedView?: boolean;
  elements: MyAcknowledgementModel[];
  pageSize: number;
}

export const MyAcknowledgement: FC<IMyAcknowledgement> = ({isInitiatedView, elements,pageSize}) => {

  const [selectedId, setSelectedId] = useState<number>(0);
  const [selectedUsers, setSelectedUsers] = useState<UserDto[]>([]);
  const [selected, setSelected] = useState<boolean>(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const onOpenModal = useCallback((item: MyAcknowledgementModel) => {
    setSelectedId(item.id);
    setIsModalOpen(true);
  }, []);
  const onCloseModal = useCallback(() => {
    setSelected(false);
    setSelectedUsers([]);
    setSelectedId(0);
    setIsModalOpen(false);
  }, []);

  const AcknowledgementOptions: string[] = useMemo(
    () => {
      if (isInitiatedView) {
        return ['In Progress', 'Completed', 'After Deadline', 'Expired'];
      } else {
        return ['In Progress', 'After Deadline'];
      }
    },
    [isInitiatedView]
  );


  const columnsView = useMemo(() => {
    const columns: IEnhancedColumn<MyAcknowledgementModel>[] = [
      
      {
        key: ColumnKey.Url,
        name: '',
        data: isInitiatedView ? CopyColumn : OpenColumn,
      },
      
      {
        key: 'created',
        name: 'Created',
        data: DateColumn,
        minWidth: 120
      },
      {
        key: 'title',
        name: 'Process/Unit',
        data: StringColumn,
        minWidth: 250
      },
      {
        key: 'comment',
        name: 'Background / Reason',
        data: RichtextColumn,
        minWidth: 260
      },
      {
        key: 'elements',
        name: `${isInitiatedView ? 'Not Opened/Confirmed' : ''} Elements`,
        minWidth: 300,
        data: LinksListColumn
      },
      {
        key: 'deadline',
        name: 'Deadline',
        data: DateColumn,
        minWidth: 120
      },
      {
        key: 'statusString',
        name: 'Status',
        data: SelectColumn,
        defaultOptions: AcknowledgementOptions,
        minWidth: 160,
        defaultFilterValue: ['In Progress', 'After Deadline']
      },
      ...(isInitiatedView
        ? [
            {
              key: SpecialColumnKey.ShowUsers,
              name: '',
              minWidth: 160,
              data: OtherColumn,
              onRender: (item: MyAcknowledgementModel) => {
                return (
                  <TheButton
                    iconProps={{
                      iconName: 'UserOptional'
                    }}
                    onClick={() => onOpenModal(item)}
                    disabled={item.status === AcknowledgementStatus.Completed}
                    primary>
                    Show Users
                  </TheButton>
                );
              }
            }
          ]
        : []),
    ];
    return columns;
  }, [onOpenModal, AcknowledgementOptions, isInitiatedView]);

  return (
    <>
          <UsersList
            selectedUsers={selectedUsers}
            setSelectedUsers={setSelectedUsers}
            selected={selected}
            setSelected={setSelected}
            acknowledgementId={selectedId}
            isModalOpen={isModalOpen}
            onCloseModal={onCloseModal}
          />
            <EnhancedDetailsList<
              MyAcknowledgementModel,
              MyAcknowledgementModel,
              MyAcknowledgementModel
            >
              hideSearch
              pageSize={pageSize}
              columns={columnsView}
              items={elements}
            />
          
        </>
  );
};
